var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#06004a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.37-77.37v-367.52q-53.2-10.76-91.85-54.06-38.65-43.29-38.65-103.68v-280h65.5v280h65v-280h65.26v280h65v-280h65.74v280q0 60.39-38.77 103.68-38.77 43.3-91.97 54.03v367.55h-65.26Zm423.13 0v-320h-115V-705q0-80.52 49.67-129.07 49.68-48.56 130.83-48.56v805.26h-65.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/food-icon.516cc6d03a7b62dfcf0b33b0d0ed4ae7.svg";
export { ForwardRef as ReactComponent };